import { useEffect, useRef } from 'react';
import type { GradedWork } from '../../../types';

type AuditDraftHydratorProps = {
  resolvedFocus: number | null;
  gradedWorks: GradedWork[];
  setAuditEditIndex: (n: number | null) => void;
  setAuditDraftScore: (s: string) => void;
  setAuditDraftFeedback: (s: string) => void;
};

/** When the focused queue row changes, load score + feedback into draft fields. */
export function AuditDraftHydrator({
  resolvedFocus,
  gradedWorks,
  setAuditEditIndex,
  setAuditDraftScore,
  setAuditDraftFeedback,
}: AuditDraftHydratorProps): null {
  const prevFocus = useRef<number | null>(null);

  useEffect(() => {
    if (resolvedFocus === null) {
      prevFocus.current = null;
      setAuditEditIndex(null);
      setAuditDraftScore('');
      setAuditDraftFeedback('');
      return;
    }
    if (prevFocus.current === resolvedFocus) return;
    prevFocus.current = resolvedFocus;
    const row = gradedWorks[resolvedFocus];
    if (!row) return;
    setAuditEditIndex(resolvedFocus);
    setAuditDraftScore(String(row.score));
    setAuditDraftFeedback(row.feedback || '');
  }, [resolvedFocus, gradedWorks, setAuditEditIndex, setAuditDraftScore, setAuditDraftFeedback]);

  return null;
}
